export default "__VITE_ASSET__BXASIXdC__"